import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { getClassName } from "../../../../cms/blocks/utils.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod"
import { CMSState } from '../../../drupalPage/state'

export type customSpacerBlockProps = {
  index: number
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type customSpacerBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function customSpacerBlock(
  props: customSpacerBlockProps,
  options?: { style?: customSpacerBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(
      onDone => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('customSpacer', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "")} />
        </InView>
      )
    )
}
